import {FC} from "react";
import Loader from "./Loader";

interface Props {
  size?: number;
  colorClass?: string;
}

const FullLoader: FC<Props> = (Props) => {
  return (
    <div className="w-full h-full grow flex items-center justify-center">
      <Loader {...Props} />
    </div>
  );
};

export default FullLoader;
